








































import { Component, Vue, Watch } from "vue-property-decorator";
import Card from "@/components/ui/card/Card.vue";
import {
  authModule,
  jimizzModule,
  metamaskModule,
  toastsModule,
  usersModule,
  vestingModule,
} from "@/store";
import { User } from "@/store/users/user";
import { AuthStatus } from "@/store/auth/auth-status.enum";
import { Schedule } from "@/store/vesting/schedule";
import { ToastType } from "@/store/toasts/toast-type.enum";

@Component({
  components: { Card },
})
export default class DashboardVesting extends Vue {
  balance = 0;

  get me(): User | null {
    return usersModule.me;
  }

  get account(): string {
    return metamaskModule.account;
  }

  get authStatus(): AuthStatus {
    return authModule.authStatus;
  }

  get isFullyAuthenticated(): boolean {
    return this.authStatus === AuthStatus.Full;
  }

  get schedules(): Schedule[] {
    return vestingModule.schedules;
  }

  get availableAmount(): number {
    return vestingModule.availableAmount;
  }

  get isGoodNetwork(): boolean {
    return metamaskModule.isGoodNetwork;
  }

  get next(): Schedule | undefined {
    const now = new Date();
    return this.schedules.filter((s) => s.date > now).shift();
  }

  get isClaimable(): boolean {
    return this.availableAmount > 0;
  }

  async fetch(): Promise<void> {
    if (
      this.isFullyAuthenticated &&
      this.me?.vestingContract &&
      this.isGoodNetwork
    ) {
      try {
        await vestingModule.init(this.me.vestingContract);
        this.balance = await jimizzModule.fetchBalance(this.me.vestingContract);
      } catch (e) {
        toastsModule.addToast({
          type: ToastType.Error,
          text: this.$t("dashboard.investments.vesting.error-fetch"),
        });
        // silent
      }
    } else {
      await vestingModule.reset();
    }
  }

  async collect(): Promise<void> {
    try {
      await vestingModule.collect();
      await vestingModule.refresh();
      await jimizzModule.fetchWalletBalance();

      toastsModule.addToast({
        type: ToastType.Success,
        text: this.$t("dashboard.investments.vesting.success"),
      });
    } catch (e) {
      toastsModule.addToast({
        type: ToastType.Error,
        text: this.$t("dashboard.investments.vesting.error"),
      });
    }
  }

  @Watch("me", { immediate: true })
  @Watch("authStatus", { immediate: true })
  @Watch("isGoodNetwork")
  onAuthStatusChanged() {
    this.fetch();
  }
}
